var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.000000pt",
    height: "100.000000pt",
    viewBox: "0 0 100.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374 855 c-78 -17 -134 -46 -168 -85 l-26 -32 0 -238 0 -239 30 -34 c110 -126 470 -126 580 0 l30 34 0 239 0 238 -26 32 c-70 82 -258 120 -420 85z m254 -20 c150 -36 212 -112 145 -180 -37 -36 -70 -52 -145 -70 -80 -19 -176 -19 -256 0 -75 18 -108 34 -145 70 -114 115 159 237 401 180z m-303 -261 c38 -13 81 -18 175 -18 140 0 198 15 263 65 l37 30 0 -192 0 -192 -38 -37 c-58 -54 -132 -75 -267 -74 -133 1 -212 24 -262 79 l-33 35 0 190 0 191 38 -30 c20 -16 60 -37 87 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393 800 c-50 -10 -80 -25 -110 -53 -29 -26 -29 -48 0 -75 37 -35 95 -53 186 -57 l86 -4 -75 8 c-97 11 -151 26 -184 52 -53 41 -14 90 90 115 149 35 325 -4 345 -77 6 -21 7 -22 8 -3 1 26 -33 58 -83 79 -47 20 -201 28 -263 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 751 c-18 -5 -40 -16 -49 -25 -36 -36 38 -65 165 -66 39 0 74 3 76 8 3 4 -34 7 -81 7 -83 0 -162 17 -162 35 0 13 60 30 125 37 68 6 168 -11 190 -33 8 -9 15 -11 15 -5 0 6 -12 18 -26 27 -29 20 -196 29 -253 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588 623 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372 458 c-28 -28 -7 -78 33 -78 28 0 45 18 45 48 0 20 -2 22 -15 12 -17 -14 -39 -4 -31 16 7 17 -16 18 -32 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562 458 c-28 -28 -7 -78 33 -78 28 0 45 18 45 48 0 20 -2 22 -15 12 -17 -14 -39 -4 -31 16 7 17 -16 18 -32 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460 349 c0 -22 22 -49 40 -49 18 0 40 27 40 49 0 6 -18 11 -40 11 -22 0 -40 -5 -40 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 324 c-31 -30 -9 -84 34 -84 24 0 50 26 50 50 0 24 -26 50 -50 50 -10 0 -26 -7 -34 -16z m66 -19 c9 -21 9 -29 -5 -42 -13 -14 -21 -14 -42 -5 -27 12 -33 40 -13 60 20 20 48 14 60 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656 324 c-31 -30 -9 -84 34 -84 24 0 50 26 50 50 0 43 -54 65 -84 34z m66 -19 c17 -37 -10 -64 -47 -47 -27 12 -33 40 -13 60 20 20 48 14 60 -13z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoll);
export default __webpack_public_path__ + "static/media/roll.e5093d36e523fc8471e3acca81754dd0.svg";
export { ForwardRef as ReactComponent };